import React from 'react';
import {Paper} from 'material-ui';
import {withStyles} from 'material-ui/styles';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {builderStyles} from '../../style/builder';
import {openEditTripFormatsSection} from '../../actions';
import {openEditSectionPopup} from '../actions';
import SectionActions from './section_actions';
import SectionTitle from './section_title';
import {removeBlankParagraphs} from '../../../../components/helpers/helpers';

class PageSection extends React.Component {
    render() {
        const {
            classes,
            visible,
            deletable,
            disableSection,
            enableSection,
            deleteSection,
            body,
            hideActions,
        } = this.props;

        let sectionPaperClassNames = classNames(
            visible ? classes.pbSection : classes.pbSectionReadonly,
            hideActions ? classes.pbSectionComparePopup : classes.pbSection,
            hideActions && !visible
                ? classes.pbSectionComparePopupReadonly
                : classes.pbSection,
            classes.root
        );

        return (
            <div>
                <Paper className={sectionPaperClassNames} elevation={2}>
                    <SectionTitle
                        classes={this.props.classes}
                        placeholderName={this.props.section.placeholder_name}
                        title={this.props.title}
                        style={{paddingBottom: '10px'}}
                        disabled={!visible}
                    />

                    <div
                        className="pbSectionEditorText"
                        dangerouslySetInnerHTML={{__html: removeBlankParagraphs(body)}}
                    />

                    <SectionActions
                        classes={classes}
                        siteId={this.props.siteId}
                        deleteSection={(ev) => deleteSection(ev, this.props.id)}
                        visible={visible}
                        invisible={!visible}
                        deletable={deletable}
                        hideActions={hideActions}
                        disableSection={(ev) =>
                            disableSection(ev, this.props.id)
                        }
                        enableSection={(ev) => enableSection(ev, this.props.id)}
                        editSection={() => {
                            this.props.openEditTripFormatsSection();
                            this.props.openEditSectionPopup(
                                this.props.pageId,
                                this.props.id,
                                this.props.section
                            );
                        }}
                    />
                </Paper>
            </div>
        );
    }
}

const card = withStyles(builderStyles)(PageSection);

export default connect(
    () => {
        return {};
    },
    {
        openEditTripFormatsSection,
        openEditSectionPopup,
    }
)(card);



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/section_trip_formats.js